export default __webpack_public_path__ + "static/media/967.ba2a488a.gif";